module.exports = __webpack_public_path__ + "static/media/phoneApplication.c532b312.svg";